<template>
  <div>
    <div class="head">
      <SecondaryTitle :align="isMobile ? 'center' : 'left'" v-if="!hideTitle">
        <span v-t="'Register'" />
      </SecondaryTitle>
      <v-btn v-if="loginLink" :to="loginLink" class="button-link" text small>
        <v-icon class="icon signArrow">mdi-arrow-right</v-icon>
        <span v-t="'Already have account?'" />
      </v-btn>
    </div>
    <base-separator v-t="'Register quickly'" class="mt-0" />
    <social-auth btn-class="ma-1" rounded dark large @auth="afterAuthenticated" />
    <base-separator v-t="'Or register with email'" />

    <form>
      <span v-show="false" v-html="csrfTokenInput"></span>
      <v-row class="spacing3">
        <v-col cols="12" sm="12" class="px-3">
          <v-text-field
            v-model="form.name"
            :error-messages="form.error('name')"
            :error="form.state('name')"
            :label="$t('Name? *')"
            :rules="rules.required"
            name="name"
            required
            v-bind="$pr.textField"
          />
        </v-col>
        <v-col cols="12" sm="12" class="px-3">
          <v-text-field
            v-model="form.email"
            :error-messages="form.error('email')"
            :error="form.state('email')"
            :label="$t('Email? *')"
            :rules="rules.email"
            name="email"
            required
            v-bind="$pr.textField"
          />
        </v-col>
        <v-col cols="12" md="6" class="px-3">
          <v-text-field
            v-model="form.password"
            :error-messages="form.error('password')"
            :error="form.state('password')"
            :label="$t('Password')"
            :rules="rules.required"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            autocomplete="new-password"
            name="password"
            required
            v-bind="$pr.textField"
          />
        </v-col>
        <v-col cols="12" md="6" class="px-3">
          <v-text-field
            v-model="form.password_confirmation"
            :error-messages="form.error('password')"
            :error="form.state('password')"
            :type="showPasswordConfirm ? 'text' : 'password'"
            @click:append="showPasswordConfirm = !showPasswordConfirm"
            :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
            :label="$t('Confirm Password')"
            :rules="rules.password"
            color="secondary"
            class="input"
            autocomplete="new-password"
            name="confirm"
            filled
            required
          />
        </v-col>
      </v-row>

      <div class="btn-area">
        <div class="form-helper">
          <div id="accept-terms" class="form-control-label">
            <v-checkbox
              name="accept-terms"
              hide-details="auto"
              v-model="form.accepts_terms"
              :label="$t('I have read and accept the terms')"
              :error="form.state('accepts_terms')"
              :error-messages="form.error('accepts_terms')"
              color="secondary"
              required
            />
            <span>
              <a href="/terms" target="_blank" class="link">
                <span v-t="'Read the terms'" />
              </a>
            </span>
          </div>
        </div>
        <v-btn
          large
          color="secondary"
          @click.prevent="onSubmit"
          type="submit"
          name="submit"
          :loading="loading"
        >
          <span v-t="'Continue'" />
        </v-btn>
      </div>

      <v-alert class="mt-3" v-if="errorMessage" type="error">
        <span v-html="errorMessage" />
      </v-alert>
    </form>
  </div>
</template>

<script>
import { csrfTokenInput } from "@/landing/common/meta/csrf-token";
import routerLink from "@/landing/static/text/link";
import SecondaryTitle from "../MainTitle/SecondaryTitle";
import SocialAuth from "@/_shared/components/auth/SocialAuth";
import Form from "@/landing/common/form";
import { parseLaravelErrors } from "@/landing/common/functions";
import validationMixin from "@/landing/mixins/validationMixin";

export default {
  mixins: [validationMixin],
  components: {
    SocialAuth,
    SecondaryTitle,
  },
  props: {
    hideTitle: {
      type: Boolean,
      default: false,
    },
    loginLink: {
      type: [Boolean, Object],
      default: () => {
        return { name: "login" };
      },
    },
  },
  data() {
    return {
      csrfTokenInput,
      routerLink: routerLink,
      //   valid: true,
      //   email: "",
      //   name: "",
      //   password: "",
      //   confirmPassword: "",
      errorMessage: null,
      loading: false,
      showPassword: false,
      showPasswordConfirm: false,
      form: new Form({
        name: "",
        email: "",
        password: "",
        password_confirmation: "",
        accepts_terms: false,
      }),

      checkbox: false,
    };
  },
  methods: {
    afterAuthenticated(response) {
      this.$store.dispatch("fetchAll");
      if (this._.get(response, ["data", "intended"], null)) {
        return window.location.replace(response.data.intended);
      }

      this.$emit("authenticated");
    },
    onSubmit() {
      //   if (this.$refs.form.validate()) {
      //     console.log("data submited");
      //   }
      this.submit();
    },
    submit() {
      this.loading = true;
      this.clearMessages();

      /* eslint-disable no-unused-vars */
      //   this.axios.get("/sanctum/csrf-cookie").then(() => {
      this.form
        .post("global/auth/register", "/")
        .then((response) => {
          this.$emit("change");
          this.loading = false;
          this.afterAuthenticated(response);
        })
        .catch((error) => {
          this.errorMessage = this._.get(
            error,
            ["response", "data", "message"],
            this._.get(error, "message", null),
          );

          this.loading = false;
        });
      //   });
    },
    clearMessages() {
      this.errorMessage = null;
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>
